<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่ม Device</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ hardwareInit.hardware_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ hardwareInit.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <label class="body-2">
              รหัส Device
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="1"
              v-model="hardware.hardware_code"
              :rules="[
                (v) => !!v || 'โปรดระบุรหัส Device',
                (v) =>
                  (v && v.length >= 1 && v.length <= 32) ||
                  'รหัส Device ต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
              ]"
              required
              clearable
              @change="checkEmpty($event, 'hardware_code')"
              outlined
              dense
            >
            </v-text-field>
            <label class="body-2">
              ชื่อ Device
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="2"
              v-model="hardware.title_th"
              :rules="[(v) => !!v || 'โปรดระบุชื่อ Device']"
              required
              clearable
              @change="checkEmpty($event, 'title_th')"
              outlined
              dense
            >
            </v-text-field>
            <label class="body-2">ชื่อ Device (อังกฤษ)</label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="3"
              v-model="hardware.title_en"
              clearable
              @change="checkEmpty($event, 'title_en')"
              outlined
              dense
            ></v-text-field>
            <label class="body-2">
              ชื่อรุ่น Device (Model)
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-autocomplete
              class="fix-google-chrome mt-1"
              tabindex="4"
              v-model="hardware.hardware_model.hardware_model_code"
              :rules="[(v) => !!v || 'โปรดระบุ Device (Model)']"
              :items="hardwareModels"
              item-text="title"
              item-value="hardware_model_code"
              outlined
              dense
              clearable
            >
            </v-autocomplete>
            <label class="body-2">พื้นที่</label>
            <v-autocomplete
              class="fix-google-chrome mt-1"
              tabindex="5"
              v-model="hardware.area.area_uuid"
              :items="areas"
              item-text="title_th"
              item-value="area_uuid"
              outlined
              dense
              clearable
            >
            </v-autocomplete>
            <label class="body-2">โน๊ตเพิ่มเติม</label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="6"
              v-model="hardware.note"
              clearable
              @change="checkEmpty($event, 'note')"
              outlined
              dense
            ></v-text-field>
            <div>
              <v-chip class="mt-4 mb-2">ตั้งค่าคำนวณเวลาทำงาน</v-chip>
              <div>
                <label class="body-2">คำนวณเวลาทำงาน</label>
                <v-select
                  v-model="hardware.is_used_for_work_time_calculation"
                  class="fix-google-chrome mt-1"
                  :items="[
                    { text: 'คำนวณเวลาทำงาน', value: true },
                    { text: 'ไม่คำนวณเวลาทำงาน', value: false },
                  ]"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isHardwareDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_3rd_party:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_3rd_party:create')
            "
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_3rd_party:update')
            "
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog
      v-model="dialogConfirmWorkTimeCalculation"
      persistent
      max-width="580"
    >
      <v-card>
        <v-card-title class="text-h5">
          คุณตั้งค่าคำนวณเวลาทำงานสำหรับ Device
        </v-card-title>
        <v-card-text style="font-size: 16px">
          คุณต้องการให้มีผลการคำนวณเวลาย้อนหลังหรือไม่
          ถ้าต้องการให้มีผลการคำนวณเวลาย้อนหลัง
          กรุณาตั้งค่าวันเริ่มต้นและวันสิ้นสุดของการคำนวณเวลาทำงาน
          <div class="d-flex mt-4">
            <div class="mr-4">
              <label class="body-2">วันเริ่มต้นคำนวณเวลาทำงาน</label>
              <date-picker
                v-model="hardware.work_time_calculation_start_date"
                class="mt-1"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="disabledAfterDateEnd"
                style="width: 100%"
              ></date-picker>
            </div>
            <div>
              <label class="body-2">วันสิ้นสุดคำนวณเวลาทำงาน</label>
              <date-picker
                v-model="hardware.work_time_calculation_end_date"
                class="mt-1"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="disabledBeforeDateStart"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            @click="onConfirmWorkTimeCalculation"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DatePicker from 'vue2-datepicker'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'

import 'vue2-datepicker/index.css'

export default {
  components: {
    ConfirmDialog,
    DatePicker,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    hardware: {
      type: Object,
    },
    hardwareInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogConfirmWorkTimeCalculation: false,
      isSetWorkTimeCalculation: false,
      selectedTab: 0,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isHardwareGeneralDataChange() {
      if (
        this.hardware.hardware_code !== this.hardwareInit.hardware_code ||
        this.hardware.title_th !== this.hardwareInit.title_th ||
        this.hardware.title_en !== this.hardwareInit.title_en ||
        this.hardware.note !== this.hardwareInit.note ||
        this.hardware?.hardware_model?.hardware_model_code !==
          this.hardwareInit?.hardware_model?.hardware_model_code ||
        this.hardware.is_used_for_work_time_calculation !==
          this.hardwareInit.is_used_for_work_time_calculation
      ) {
        return true
      }
      return false
    },
    isHardwareWorkTimeDataChange() {
      if (
        this.hardware.is_used_for_work_time_calculation !==
        this.hardwareInit.is_used_for_work_time_calculation
      ) {
        return true
      }
      return false
    },
    isHardwareAreaDataChange() {
      if (this.hardware?.area.area_uuid !== this.hardwareInit?.area.area_uuid) {
        return true
      }
      return false
    },
    isHardwareDataChange() {
      if (
        this.isHardwareGeneralDataChange ||
        this.isHardwareAreaDataChange ||
        this.isHardwareWorkTimeDataChange
      ) {
        this.$emit('isHardwareDataChange', true)
        return true
      }
      this.$emit('isHardwareDataChange', false)
      return false
    },
    hardwareModels() {
      return this.$store.state.hardware.hardwareModels
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  methods: {
    ...mapActions({
      addHardware3rdParty: 'hardware3rdParty/addHardware3rdParty',
      editHardware3rdParty: 'hardware3rdParty/editHardware3rdParty',
      deleteHardware3rdParty: 'hardware3rdParty/deleteHardware3rdParty',
    }),
    onConfirmWorkTimeCalculation() {
      this.isSetWorkTimeCalculation = true
      this.dialogConfirmWorkTimeCalculation = false

      this.onSave()
    },
    disabledAfterDateEnd(date) {
      return date > new Date(this.hardware.work_time_calculation_end_date)
    },
    disabledBeforeDateStart(date) {
      return date < new Date(this.hardware.work_time_calculation_start_date)
    },
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    checkEmpty(value, field) {
      if (value) {
        this.hardware[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Device นี้ใช่หรือไม่',
        value: `${this.hardwareInit.hardware_code} - ${this.hardwareInit.title_th}`,
        item: this.hardware,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(hardware) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDialogDeleteLoading = true

        await this.deleteHardware3rdParty({
          company_uuid,
          hardware_3rd_party_uuid: hardware.hardware_uuid,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false
      }
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          const payload = {
            company_uuid,
            data: {
              hardware_code: this.hardware.hardware_code,
              title_th: this.hardware.title_th,
              title_en: this.hardware.title_en,
              note: this.hardware.note,
              hardware_model_code:
                this.hardware.hardware_model.hardware_model_code,
              is_used_for_work_time_calculation:
                this.hardware.is_used_for_work_time_calculation || false,
            },
          }

          const data = await this.addHardware3rdParty(payload)

          if (this.hardware.area) {
            await this.editHardware3rdParty({
              company_uuid,
              hardware_3rd_party_uuid: data.hardware_uuid,
              data: {
                ...data,
                hardware_model_code: data.hardware_model.hardware_model_code,
                area_uuid: this.hardware.area.area_uuid,
              },
            })
          }

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    async onSave() {
      if (this.isHardwareWorkTimeDataChange && !this.isSetWorkTimeCalculation) {
        this.dialogConfirmWorkTimeCalculation = true
        return
      }

      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          const payload = {
            company_uuid,
            hardware_3rd_party_uuid: this.hardware.hardware_uuid,
            data: {
              hardware_code: this.hardware.hardware_code,
              title_th: this.hardware.title_th,
              title_en: this.hardware.title_en,
              note: this.hardware.note,
              hardware_model_code:
                this.hardware.hardware_model.hardware_model_code,
              area_uuid: this.hardware.area
                ? this.hardware.area.area_uuid
                : null,
              is_used_for_work_time_calculation:
                this.hardware.is_used_for_work_time_calculation || false,
              work_time_calculation_start_datetime: this.hardware
                .work_time_calculation_start_date
                ? moment(this.hardware.work_time_calculation_start_date)
                    .set({
                      hour: 0,
                      minute: 0,
                      second: 0,
                      millisecond: 0,
                    })
                    .format()
                : null,
              work_time_calculation_end_datetime: this.hardware
                .work_time_calculation_end_date
                ? moment(this.hardware.work_time_calculation_end_date)
                    .set({
                      hour: 23,
                      minute: 59,
                      second: 59,
                      millisecond: 0,
                    })
                    .format()
                : null,
            },
          }

          await this.editHardware3rdParty(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)

          this.isSetWorkTimeCalculation = false
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted')
        this.$refs.form.resetValidation()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted')
      this.$refs.form.resetValidation()
    },
    onReset() {
      this.$emit('onReset', this.formAction)
      this.$refs.form.resetValidation()
    },
  },
}
</script>
